/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AppRouteImport } from "./routes/_app";
import { Route as AuthRouteImport } from "./routes/_auth";
import { Route as ManageRouteImport } from "./routes/manage";
import { Route as SharedRouteImport } from "./routes/shared";
import { Route as AppOnboardingRouteImport } from "./routes/_app/onboarding";
import { Route as AppPlanRouteImport } from "./routes/_app/plan";
import { Route as AppWorkspacesRouteImport } from "./routes/_app/workspaces";
import { Route as AuthSetPasswordRouteImport } from "./routes/_auth/set-password";
import { Route as AuthSigninRouteImport } from "./routes/_auth/signin";
import { Route as AuthSignupRouteImport } from "./routes/_auth/signup";
import { Route as InviteTokenRouteImport } from "./routes/invite.$token";
import { Route as ManageIndexRouteImport } from "./routes/manage.index";
import { Route as ManageBillingRouteImport } from "./routes/manage.billing";
import { Route as ManageConnectionsRouteImport } from "./routes/manage.connections";
import { Route as ManageCreditsRouteImport } from "./routes/manage.credits";
import { Route as ManageDataEventsRouteImport } from "./routes/manage.data-events";
import { Route as ManageLlmLogsRouteImport } from "./routes/manage.llm-logs";
import { Route as ManageMembersRouteImport } from "./routes/manage.members";
import { Route as ManageOrgRouteImport } from "./routes/manage.org";
import { Route as ManagePlatformWritesRouteImport } from "./routes/manage.platform-writes";
import { Route as SSlugRouteImport } from "./routes/s.$slug";
import { Route as AppAdminOrgRouteImport } from "./routes/_app/admin.org";
import { Route as AppPlanIndexRouteImport } from "./routes/_app/plan.index";
import { Route as AppPlanAllWorkRouteImport } from "./routes/_app/plan.all-work";
import { Route as AppSettingsProfileRouteImport } from "./routes/_app/settings.profile";
import { Route as AppVProposalIdRouteImport } from "./routes/_app/v.$proposalId";
import { Route as ManageAppsIndexRouteImport } from "./routes/manage.apps.index";
import { Route as ManageAppsIdRouteImport } from "./routes/manage.apps.$id";
import { Route as ManageDatasetsIndexRouteImport } from "./routes/manage.datasets.index";
import { Route as ManageObjectivesIndexRouteImport } from "./routes/manage.objectives.index";
import { Route as ManageObjectivesIdRouteImport } from "./routes/manage.objectives.$id";
import { Route as ManageProjectsIndexRouteImport } from "./routes/manage.projects.index";
import { Route as ManageProjectsIdRouteImport } from "./routes/manage.projects.$id";
import { Route as ManageSitesIndexRouteImport } from "./routes/manage.sites.index";
import { Route as ManageWorkspacesIndexRouteImport } from "./routes/manage.workspaces.index";
import { Route as ManageWorkspacesIdRouteImport } from "./routes/manage.workspaces.$id";
import { Route as AppPlanOObjectiveSlugRouteImport } from "./routes/_app/plan.o.$objectiveSlug";
import { Route as AppPlanPProjectSlugRouteImport } from "./routes/_app/plan.p.$projectSlug";
import { Route as AppPlanWSlugRouteImport } from "./routes/_app/plan.w.$slug";
import { Route as AppWSlugIndexRouteImport } from "./routes/_app/w.$slug.index";
import { Route as AppWSlugThreadsRouteImport } from "./routes/_app/w.$slug.threads";
import { Route as ManageDatasetsIdIndexRouteImport } from "./routes/manage.datasets.$id.index";
import { Route as ManageDatasetsIdDataRouteImport } from "./routes/manage.datasets.$id.data";
import { Route as AppPlanOObjectiveSlugIndexRouteImport } from "./routes/_app/plan.o.$objectiveSlug.index";
import { Route as AppPlanPProjectSlugIndexRouteImport } from "./routes/_app/plan.p.$projectSlug.index";
import { Route as AppWSlugCCanvasIdRouteImport } from "./routes/_app/w.$slug.c.$canvasId";
import { Route as AppWSlugCasesCaseIdRouteImport } from "./routes/_app/w.$slug.cases.$caseId";
import { Route as ManageDatasetsIdFilesAssetIdRouteImport } from "./routes/manage.datasets.$id.files.$assetId";
import { Route as AppPlanOObjectiveSlugKrKrIdRouteImport } from "./routes/_app/plan.o.$objectiveSlug.kr.$krId";
import { Route as AppPlanPProjectSlugWpWpIdRouteImport } from "./routes/_app/plan.p.$projectSlug.wp.$wpId";
import { Route as AppWSlugCCanvasIdAArtifactIdRouteImport } from "./routes/_app/w.$slug.c.$canvasId.a.$artifactId";
import { Route as AppPlanPProjectSlugWpWpIdTTaskIdRouteImport } from "./routes/_app/plan.p.$projectSlug.wp.$wpId.t.$taskId";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRoute = AuthRouteImport.update({
  id: "/_auth",
  getParentRoute: () => rootRouteImport,
} as any);
const ManageRoute = ManageRouteImport.update({
  id: "/manage",
  path: "/manage",
  getParentRoute: () => rootRouteImport,
} as any);
const SharedRoute = SharedRouteImport.update({
  id: "/shared",
  path: "/shared",
  getParentRoute: () => rootRouteImport,
} as any);
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => AppRoute,
} as any);
const AppPlanRoute = AppPlanRouteImport.update({
  id: "/plan",
  path: "/plan",
  getParentRoute: () => AppRoute,
} as any);
const AppWorkspacesRoute = AppWorkspacesRouteImport.update({
  id: "/workspaces",
  path: "/workspaces",
  getParentRoute: () => AppRoute,
} as any);
const AuthSetPasswordRoute = AuthSetPasswordRouteImport.update({
  id: "/set-password",
  path: "/set-password",
  getParentRoute: () => AuthRoute,
} as any);
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: "/signin",
  path: "/signin",
  getParentRoute: () => AuthRoute,
} as any);
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => AuthRoute,
} as any);
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: "/invite/$token",
  path: "/invite/$token",
  getParentRoute: () => rootRouteImport,
} as any);
const ManageIndexRoute = ManageIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ManageRoute,
} as any);
const ManageBillingRoute = ManageBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => ManageRoute,
} as any);
const ManageConnectionsRoute = ManageConnectionsRouteImport.update({
  id: "/connections",
  path: "/connections",
  getParentRoute: () => ManageRoute,
} as any);
const ManageCreditsRoute = ManageCreditsRouteImport.update({
  id: "/credits",
  path: "/credits",
  getParentRoute: () => ManageRoute,
} as any);
const ManageDataEventsRoute = ManageDataEventsRouteImport.update({
  id: "/data-events",
  path: "/data-events",
  getParentRoute: () => ManageRoute,
} as any);
const ManageLlmLogsRoute = ManageLlmLogsRouteImport.update({
  id: "/llm-logs",
  path: "/llm-logs",
  getParentRoute: () => ManageRoute,
} as any);
const ManageMembersRoute = ManageMembersRouteImport.update({
  id: "/members",
  path: "/members",
  getParentRoute: () => ManageRoute,
} as any);
const ManageOrgRoute = ManageOrgRouteImport.update({
  id: "/org",
  path: "/org",
  getParentRoute: () => ManageRoute,
} as any);
const ManagePlatformWritesRoute = ManagePlatformWritesRouteImport.update({
  id: "/platform-writes",
  path: "/platform-writes",
  getParentRoute: () => ManageRoute,
} as any);
const SSlugRoute = SSlugRouteImport.update({
  id: "/s/$slug",
  path: "/s/$slug",
  getParentRoute: () => rootRouteImport,
} as any);
const AppAdminOrgRoute = AppAdminOrgRouteImport.update({
  id: "/admin/org",
  path: "/admin/org",
  getParentRoute: () => AppRoute,
} as any);
const AppPlanIndexRoute = AppPlanIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppPlanRoute,
} as any);
const AppPlanAllWorkRoute = AppPlanAllWorkRouteImport.update({
  id: "/all-work",
  path: "/all-work",
  getParentRoute: () => AppPlanRoute,
} as any);
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: "/settings/profile",
  path: "/settings/profile",
  getParentRoute: () => AppRoute,
} as any);
const AppVProposalIdRoute = AppVProposalIdRouteImport.update({
  id: "/v/$proposalId",
  path: "/v/$proposalId",
  getParentRoute: () => AppRoute,
} as any);
const ManageAppsIndexRoute = ManageAppsIndexRouteImport.update({
  id: "/apps/",
  path: "/apps/",
  getParentRoute: () => ManageRoute,
} as any);
const ManageAppsIdRoute = ManageAppsIdRouteImport.update({
  id: "/apps/$id",
  path: "/apps/$id",
  getParentRoute: () => ManageRoute,
} as any);
const ManageDatasetsIndexRoute = ManageDatasetsIndexRouteImport.update({
  id: "/datasets/",
  path: "/datasets/",
  getParentRoute: () => ManageRoute,
} as any);
const ManageObjectivesIndexRoute = ManageObjectivesIndexRouteImport.update({
  id: "/objectives/",
  path: "/objectives/",
  getParentRoute: () => ManageRoute,
} as any);
const ManageObjectivesIdRoute = ManageObjectivesIdRouteImport.update({
  id: "/objectives/$id",
  path: "/objectives/$id",
  getParentRoute: () => ManageRoute,
} as any);
const ManageProjectsIndexRoute = ManageProjectsIndexRouteImport.update({
  id: "/projects/",
  path: "/projects/",
  getParentRoute: () => ManageRoute,
} as any);
const ManageProjectsIdRoute = ManageProjectsIdRouteImport.update({
  id: "/projects/$id",
  path: "/projects/$id",
  getParentRoute: () => ManageRoute,
} as any);
const ManageSitesIndexRoute = ManageSitesIndexRouteImport.update({
  id: "/sites/",
  path: "/sites/",
  getParentRoute: () => ManageRoute,
} as any);
const ManageWorkspacesIndexRoute = ManageWorkspacesIndexRouteImport.update({
  id: "/workspaces/",
  path: "/workspaces/",
  getParentRoute: () => ManageRoute,
} as any);
const ManageWorkspacesIdRoute = ManageWorkspacesIdRouteImport.update({
  id: "/workspaces/$id",
  path: "/workspaces/$id",
  getParentRoute: () => ManageRoute,
} as any);
const AppPlanOObjectiveSlugRoute = AppPlanOObjectiveSlugRouteImport.update({
  id: "/o/$objectiveSlug",
  path: "/o/$objectiveSlug",
  getParentRoute: () => AppPlanRoute,
} as any);
const AppPlanPProjectSlugRoute = AppPlanPProjectSlugRouteImport.update({
  id: "/p/$projectSlug",
  path: "/p/$projectSlug",
  getParentRoute: () => AppPlanRoute,
} as any);
const AppPlanWSlugRoute = AppPlanWSlugRouteImport.update({
  id: "/w/$slug",
  path: "/w/$slug",
  getParentRoute: () => AppPlanRoute,
} as any);
const AppWSlugIndexRoute = AppWSlugIndexRouteImport.update({
  id: "/w/$slug/",
  path: "/w/$slug/",
  getParentRoute: () => AppRoute,
} as any);
const AppWSlugThreadsRoute = AppWSlugThreadsRouteImport.update({
  id: "/w/$slug/threads",
  path: "/w/$slug/threads",
  getParentRoute: () => AppRoute,
} as any);
const ManageDatasetsIdIndexRoute = ManageDatasetsIdIndexRouteImport.update({
  id: "/datasets/$id/",
  path: "/datasets/$id/",
  getParentRoute: () => ManageRoute,
} as any);
const ManageDatasetsIdDataRoute = ManageDatasetsIdDataRouteImport.update({
  id: "/datasets/$id/data",
  path: "/datasets/$id/data",
  getParentRoute: () => ManageRoute,
} as any);
const AppPlanOObjectiveSlugIndexRoute =
  AppPlanOObjectiveSlugIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AppPlanOObjectiveSlugRoute,
  } as any);
const AppPlanPProjectSlugIndexRoute =
  AppPlanPProjectSlugIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AppPlanPProjectSlugRoute,
  } as any);
const AppWSlugCCanvasIdRoute = AppWSlugCCanvasIdRouteImport.update({
  id: "/w/$slug/c/$canvasId",
  path: "/w/$slug/c/$canvasId",
  getParentRoute: () => AppRoute,
} as any);
const AppWSlugCasesCaseIdRoute = AppWSlugCasesCaseIdRouteImport.update({
  id: "/w/$slug/cases/$caseId",
  path: "/w/$slug/cases/$caseId",
  getParentRoute: () => AppRoute,
} as any);
const ManageDatasetsIdFilesAssetIdRoute =
  ManageDatasetsIdFilesAssetIdRouteImport.update({
    id: "/datasets/$id/files/$assetId",
    path: "/datasets/$id/files/$assetId",
    getParentRoute: () => ManageRoute,
  } as any);
const AppPlanOObjectiveSlugKrKrIdRoute =
  AppPlanOObjectiveSlugKrKrIdRouteImport.update({
    id: "/kr/$krId",
    path: "/kr/$krId",
    getParentRoute: () => AppPlanOObjectiveSlugRoute,
  } as any);
const AppPlanPProjectSlugWpWpIdRoute =
  AppPlanPProjectSlugWpWpIdRouteImport.update({
    id: "/wp/$wpId",
    path: "/wp/$wpId",
    getParentRoute: () => AppPlanPProjectSlugRoute,
  } as any);
const AppWSlugCCanvasIdAArtifactIdRoute =
  AppWSlugCCanvasIdAArtifactIdRouteImport.update({
    id: "/a/$artifactId",
    path: "/a/$artifactId",
    getParentRoute: () => AppWSlugCCanvasIdRoute,
  } as any);
const AppPlanPProjectSlugWpWpIdTTaskIdRoute =
  AppPlanPProjectSlugWpWpIdTTaskIdRouteImport.update({
    id: "/t/$taskId",
    path: "/t/$taskId",
    getParentRoute: () => AppPlanPProjectSlugWpWpIdRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/manage": typeof ManageRouteWithChildren;
  "/shared": typeof SharedRoute;
  "/onboarding": typeof AppOnboardingRoute;
  "/plan": typeof AppPlanRouteWithChildren;
  "/workspaces": typeof AppWorkspacesRoute;
  "/set-password": typeof AuthSetPasswordRoute;
  "/signin": typeof AuthSigninRoute;
  "/signup": typeof AuthSignupRoute;
  "/invite/$token": typeof InviteTokenRoute;
  "/manage/billing": typeof ManageBillingRoute;
  "/manage/connections": typeof ManageConnectionsRoute;
  "/manage/credits": typeof ManageCreditsRoute;
  "/manage/data-events": typeof ManageDataEventsRoute;
  "/manage/llm-logs": typeof ManageLlmLogsRoute;
  "/manage/members": typeof ManageMembersRoute;
  "/manage/org": typeof ManageOrgRoute;
  "/manage/platform-writes": typeof ManagePlatformWritesRoute;
  "/s/$slug": typeof SSlugRoute;
  "/manage/": typeof ManageIndexRoute;
  "/admin/org": typeof AppAdminOrgRoute;
  "/plan/all-work": typeof AppPlanAllWorkRoute;
  "/settings/profile": typeof AppSettingsProfileRoute;
  "/v/$proposalId": typeof AppVProposalIdRoute;
  "/manage/apps/$id": typeof ManageAppsIdRoute;
  "/manage/objectives/$id": typeof ManageObjectivesIdRoute;
  "/manage/projects/$id": typeof ManageProjectsIdRoute;
  "/manage/workspaces/$id": typeof ManageWorkspacesIdRoute;
  "/plan/": typeof AppPlanIndexRoute;
  "/manage/apps/": typeof ManageAppsIndexRoute;
  "/manage/datasets/": typeof ManageDatasetsIndexRoute;
  "/manage/objectives/": typeof ManageObjectivesIndexRoute;
  "/manage/projects/": typeof ManageProjectsIndexRoute;
  "/manage/sites/": typeof ManageSitesIndexRoute;
  "/manage/workspaces/": typeof ManageWorkspacesIndexRoute;
  "/plan/o/$objectiveSlug": typeof AppPlanOObjectiveSlugRouteWithChildren;
  "/plan/p/$projectSlug": typeof AppPlanPProjectSlugRouteWithChildren;
  "/plan/w/$slug": typeof AppPlanWSlugRoute;
  "/w/$slug/threads": typeof AppWSlugThreadsRoute;
  "/manage/datasets/$id/data": typeof ManageDatasetsIdDataRoute;
  "/w/$slug/": typeof AppWSlugIndexRoute;
  "/manage/datasets/$id/": typeof ManageDatasetsIdIndexRoute;
  "/w/$slug/c/$canvasId": typeof AppWSlugCCanvasIdRouteWithChildren;
  "/w/$slug/cases/$caseId": typeof AppWSlugCasesCaseIdRoute;
  "/manage/datasets/$id/files/$assetId": typeof ManageDatasetsIdFilesAssetIdRoute;
  "/plan/o/$objectiveSlug/": typeof AppPlanOObjectiveSlugIndexRoute;
  "/plan/p/$projectSlug/": typeof AppPlanPProjectSlugIndexRoute;
  "/plan/o/$objectiveSlug/kr/$krId": typeof AppPlanOObjectiveSlugKrKrIdRoute;
  "/plan/p/$projectSlug/wp/$wpId": typeof AppPlanPProjectSlugWpWpIdRouteWithChildren;
  "/w/$slug/c/$canvasId/a/$artifactId": typeof AppWSlugCCanvasIdAArtifactIdRoute;
  "/plan/p/$projectSlug/wp/$wpId/t/$taskId": typeof AppPlanPProjectSlugWpWpIdTTaskIdRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/shared": typeof SharedRoute;
  "/onboarding": typeof AppOnboardingRoute;
  "/workspaces": typeof AppWorkspacesRoute;
  "/set-password": typeof AuthSetPasswordRoute;
  "/signin": typeof AuthSigninRoute;
  "/signup": typeof AuthSignupRoute;
  "/invite/$token": typeof InviteTokenRoute;
  "/manage/billing": typeof ManageBillingRoute;
  "/manage/connections": typeof ManageConnectionsRoute;
  "/manage/credits": typeof ManageCreditsRoute;
  "/manage/data-events": typeof ManageDataEventsRoute;
  "/manage/llm-logs": typeof ManageLlmLogsRoute;
  "/manage/members": typeof ManageMembersRoute;
  "/manage/org": typeof ManageOrgRoute;
  "/manage/platform-writes": typeof ManagePlatformWritesRoute;
  "/s/$slug": typeof SSlugRoute;
  "/manage": typeof ManageIndexRoute;
  "/admin/org": typeof AppAdminOrgRoute;
  "/plan/all-work": typeof AppPlanAllWorkRoute;
  "/settings/profile": typeof AppSettingsProfileRoute;
  "/v/$proposalId": typeof AppVProposalIdRoute;
  "/manage/apps/$id": typeof ManageAppsIdRoute;
  "/manage/objectives/$id": typeof ManageObjectivesIdRoute;
  "/manage/projects/$id": typeof ManageProjectsIdRoute;
  "/manage/workspaces/$id": typeof ManageWorkspacesIdRoute;
  "/plan": typeof AppPlanIndexRoute;
  "/manage/apps": typeof ManageAppsIndexRoute;
  "/manage/datasets": typeof ManageDatasetsIndexRoute;
  "/manage/objectives": typeof ManageObjectivesIndexRoute;
  "/manage/projects": typeof ManageProjectsIndexRoute;
  "/manage/sites": typeof ManageSitesIndexRoute;
  "/manage/workspaces": typeof ManageWorkspacesIndexRoute;
  "/plan/w/$slug": typeof AppPlanWSlugRoute;
  "/w/$slug/threads": typeof AppWSlugThreadsRoute;
  "/manage/datasets/$id/data": typeof ManageDatasetsIdDataRoute;
  "/w/$slug": typeof AppWSlugIndexRoute;
  "/manage/datasets/$id": typeof ManageDatasetsIdIndexRoute;
  "/w/$slug/c/$canvasId": typeof AppWSlugCCanvasIdRouteWithChildren;
  "/w/$slug/cases/$caseId": typeof AppWSlugCasesCaseIdRoute;
  "/manage/datasets/$id/files/$assetId": typeof ManageDatasetsIdFilesAssetIdRoute;
  "/plan/o/$objectiveSlug": typeof AppPlanOObjectiveSlugIndexRoute;
  "/plan/p/$projectSlug": typeof AppPlanPProjectSlugIndexRoute;
  "/plan/o/$objectiveSlug/kr/$krId": typeof AppPlanOObjectiveSlugKrKrIdRoute;
  "/plan/p/$projectSlug/wp/$wpId": typeof AppPlanPProjectSlugWpWpIdRouteWithChildren;
  "/w/$slug/c/$canvasId/a/$artifactId": typeof AppWSlugCCanvasIdAArtifactIdRoute;
  "/plan/p/$projectSlug/wp/$wpId/t/$taskId": typeof AppPlanPProjectSlugWpWpIdTTaskIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_app": typeof AppRouteWithChildren;
  "/_auth": typeof AuthRouteWithChildren;
  "/manage": typeof ManageRouteWithChildren;
  "/shared": typeof SharedRoute;
  "/_app/onboarding": typeof AppOnboardingRoute;
  "/_app/plan": typeof AppPlanRouteWithChildren;
  "/_app/workspaces": typeof AppWorkspacesRoute;
  "/_auth/set-password": typeof AuthSetPasswordRoute;
  "/_auth/signin": typeof AuthSigninRoute;
  "/_auth/signup": typeof AuthSignupRoute;
  "/invite/$token": typeof InviteTokenRoute;
  "/manage/billing": typeof ManageBillingRoute;
  "/manage/connections": typeof ManageConnectionsRoute;
  "/manage/credits": typeof ManageCreditsRoute;
  "/manage/data-events": typeof ManageDataEventsRoute;
  "/manage/llm-logs": typeof ManageLlmLogsRoute;
  "/manage/members": typeof ManageMembersRoute;
  "/manage/org": typeof ManageOrgRoute;
  "/manage/platform-writes": typeof ManagePlatformWritesRoute;
  "/s/$slug": typeof SSlugRoute;
  "/manage/": typeof ManageIndexRoute;
  "/_app/admin/org": typeof AppAdminOrgRoute;
  "/_app/plan/all-work": typeof AppPlanAllWorkRoute;
  "/_app/settings/profile": typeof AppSettingsProfileRoute;
  "/_app/v/$proposalId": typeof AppVProposalIdRoute;
  "/manage/apps/$id": typeof ManageAppsIdRoute;
  "/manage/objectives/$id": typeof ManageObjectivesIdRoute;
  "/manage/projects/$id": typeof ManageProjectsIdRoute;
  "/manage/workspaces/$id": typeof ManageWorkspacesIdRoute;
  "/_app/plan/": typeof AppPlanIndexRoute;
  "/manage/apps/": typeof ManageAppsIndexRoute;
  "/manage/datasets/": typeof ManageDatasetsIndexRoute;
  "/manage/objectives/": typeof ManageObjectivesIndexRoute;
  "/manage/projects/": typeof ManageProjectsIndexRoute;
  "/manage/sites/": typeof ManageSitesIndexRoute;
  "/manage/workspaces/": typeof ManageWorkspacesIndexRoute;
  "/_app/plan/o/$objectiveSlug": typeof AppPlanOObjectiveSlugRouteWithChildren;
  "/_app/plan/p/$projectSlug": typeof AppPlanPProjectSlugRouteWithChildren;
  "/_app/plan/w/$slug": typeof AppPlanWSlugRoute;
  "/_app/w/$slug/threads": typeof AppWSlugThreadsRoute;
  "/manage/datasets/$id/data": typeof ManageDatasetsIdDataRoute;
  "/_app/w/$slug/": typeof AppWSlugIndexRoute;
  "/manage/datasets/$id/": typeof ManageDatasetsIdIndexRoute;
  "/_app/w/$slug/c/$canvasId": typeof AppWSlugCCanvasIdRouteWithChildren;
  "/_app/w/$slug/cases/$caseId": typeof AppWSlugCasesCaseIdRoute;
  "/manage/datasets/$id/files/$assetId": typeof ManageDatasetsIdFilesAssetIdRoute;
  "/_app/plan/o/$objectiveSlug/": typeof AppPlanOObjectiveSlugIndexRoute;
  "/_app/plan/p/$projectSlug/": typeof AppPlanPProjectSlugIndexRoute;
  "/_app/plan/o/$objectiveSlug/kr/$krId": typeof AppPlanOObjectiveSlugKrKrIdRoute;
  "/_app/plan/p/$projectSlug/wp/$wpId": typeof AppPlanPProjectSlugWpWpIdRouteWithChildren;
  "/_app/w/$slug/c/$canvasId/a/$artifactId": typeof AppWSlugCCanvasIdAArtifactIdRoute;
  "/_app/plan/p/$projectSlug/wp/$wpId/t/$taskId": typeof AppPlanPProjectSlugWpWpIdTTaskIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/manage"
    | "/shared"
    | "/onboarding"
    | "/plan"
    | "/workspaces"
    | "/set-password"
    | "/signin"
    | "/signup"
    | "/invite/$token"
    | "/manage/billing"
    | "/manage/connections"
    | "/manage/credits"
    | "/manage/data-events"
    | "/manage/llm-logs"
    | "/manage/members"
    | "/manage/org"
    | "/manage/platform-writes"
    | "/s/$slug"
    | "/manage/"
    | "/admin/org"
    | "/plan/all-work"
    | "/settings/profile"
    | "/v/$proposalId"
    | "/manage/apps/$id"
    | "/manage/objectives/$id"
    | "/manage/projects/$id"
    | "/manage/workspaces/$id"
    | "/plan/"
    | "/manage/apps/"
    | "/manage/datasets/"
    | "/manage/objectives/"
    | "/manage/projects/"
    | "/manage/sites/"
    | "/manage/workspaces/"
    | "/plan/o/$objectiveSlug"
    | "/plan/p/$projectSlug"
    | "/plan/w/$slug"
    | "/w/$slug/threads"
    | "/manage/datasets/$id/data"
    | "/w/$slug/"
    | "/manage/datasets/$id/"
    | "/w/$slug/c/$canvasId"
    | "/w/$slug/cases/$caseId"
    | "/manage/datasets/$id/files/$assetId"
    | "/plan/o/$objectiveSlug/"
    | "/plan/p/$projectSlug/"
    | "/plan/o/$objectiveSlug/kr/$krId"
    | "/plan/p/$projectSlug/wp/$wpId"
    | "/w/$slug/c/$canvasId/a/$artifactId"
    | "/plan/p/$projectSlug/wp/$wpId/t/$taskId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/shared"
    | "/onboarding"
    | "/workspaces"
    | "/set-password"
    | "/signin"
    | "/signup"
    | "/invite/$token"
    | "/manage/billing"
    | "/manage/connections"
    | "/manage/credits"
    | "/manage/data-events"
    | "/manage/llm-logs"
    | "/manage/members"
    | "/manage/org"
    | "/manage/platform-writes"
    | "/s/$slug"
    | "/manage"
    | "/admin/org"
    | "/plan/all-work"
    | "/settings/profile"
    | "/v/$proposalId"
    | "/manage/apps/$id"
    | "/manage/objectives/$id"
    | "/manage/projects/$id"
    | "/manage/workspaces/$id"
    | "/plan"
    | "/manage/apps"
    | "/manage/datasets"
    | "/manage/objectives"
    | "/manage/projects"
    | "/manage/sites"
    | "/manage/workspaces"
    | "/plan/w/$slug"
    | "/w/$slug/threads"
    | "/manage/datasets/$id/data"
    | "/w/$slug"
    | "/manage/datasets/$id"
    | "/w/$slug/c/$canvasId"
    | "/w/$slug/cases/$caseId"
    | "/manage/datasets/$id/files/$assetId"
    | "/plan/o/$objectiveSlug"
    | "/plan/p/$projectSlug"
    | "/plan/o/$objectiveSlug/kr/$krId"
    | "/plan/p/$projectSlug/wp/$wpId"
    | "/w/$slug/c/$canvasId/a/$artifactId"
    | "/plan/p/$projectSlug/wp/$wpId/t/$taskId";
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/_auth"
    | "/manage"
    | "/shared"
    | "/_app/onboarding"
    | "/_app/plan"
    | "/_app/workspaces"
    | "/_auth/set-password"
    | "/_auth/signin"
    | "/_auth/signup"
    | "/invite/$token"
    | "/manage/billing"
    | "/manage/connections"
    | "/manage/credits"
    | "/manage/data-events"
    | "/manage/llm-logs"
    | "/manage/members"
    | "/manage/org"
    | "/manage/platform-writes"
    | "/s/$slug"
    | "/manage/"
    | "/_app/admin/org"
    | "/_app/plan/all-work"
    | "/_app/settings/profile"
    | "/_app/v/$proposalId"
    | "/manage/apps/$id"
    | "/manage/objectives/$id"
    | "/manage/projects/$id"
    | "/manage/workspaces/$id"
    | "/_app/plan/"
    | "/manage/apps/"
    | "/manage/datasets/"
    | "/manage/objectives/"
    | "/manage/projects/"
    | "/manage/sites/"
    | "/manage/workspaces/"
    | "/_app/plan/o/$objectiveSlug"
    | "/_app/plan/p/$projectSlug"
    | "/_app/plan/w/$slug"
    | "/_app/w/$slug/threads"
    | "/manage/datasets/$id/data"
    | "/_app/w/$slug/"
    | "/manage/datasets/$id/"
    | "/_app/w/$slug/c/$canvasId"
    | "/_app/w/$slug/cases/$caseId"
    | "/manage/datasets/$id/files/$assetId"
    | "/_app/plan/o/$objectiveSlug/"
    | "/_app/plan/p/$projectSlug/"
    | "/_app/plan/o/$objectiveSlug/kr/$krId"
    | "/_app/plan/p/$projectSlug/wp/$wpId"
    | "/_app/w/$slug/c/$canvasId/a/$artifactId"
    | "/_app/plan/p/$projectSlug/wp/$wpId/t/$taskId";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRouteWithChildren;
  AuthRoute: typeof AuthRouteWithChildren;
  ManageRoute: typeof ManageRouteWithChildren;
  SharedRoute: typeof SharedRoute;
  InviteTokenRoute: typeof InviteTokenRoute;
  SSlugRoute: typeof SSlugRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_auth": {
      id: "/_auth";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/manage": {
      id: "/manage";
      path: "/manage";
      fullPath: "/manage";
      preLoaderRoute: typeof ManageRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/shared": {
      id: "/shared";
      path: "/shared";
      fullPath: "/shared";
      preLoaderRoute: typeof SharedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/onboarding": {
      id: "/_app/onboarding";
      path: "/onboarding";
      fullPath: "/onboarding";
      preLoaderRoute: typeof AppOnboardingRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/plan": {
      id: "/_app/plan";
      path: "/plan";
      fullPath: "/plan";
      preLoaderRoute: typeof AppPlanRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/workspaces": {
      id: "/_app/workspaces";
      path: "/workspaces";
      fullPath: "/workspaces";
      preLoaderRoute: typeof AppWorkspacesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_auth/set-password": {
      id: "/_auth/set-password";
      path: "/set-password";
      fullPath: "/set-password";
      preLoaderRoute: typeof AuthSetPasswordRouteImport;
      parentRoute: typeof AuthRoute;
    };
    "/_auth/signin": {
      id: "/_auth/signin";
      path: "/signin";
      fullPath: "/signin";
      preLoaderRoute: typeof AuthSigninRouteImport;
      parentRoute: typeof AuthRoute;
    };
    "/_auth/signup": {
      id: "/_auth/signup";
      path: "/signup";
      fullPath: "/signup";
      preLoaderRoute: typeof AuthSignupRouteImport;
      parentRoute: typeof AuthRoute;
    };
    "/invite/$token": {
      id: "/invite/$token";
      path: "/invite/$token";
      fullPath: "/invite/$token";
      preLoaderRoute: typeof InviteTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/manage/": {
      id: "/manage/";
      path: "/";
      fullPath: "/manage/";
      preLoaderRoute: typeof ManageIndexRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/billing": {
      id: "/manage/billing";
      path: "/billing";
      fullPath: "/manage/billing";
      preLoaderRoute: typeof ManageBillingRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/connections": {
      id: "/manage/connections";
      path: "/connections";
      fullPath: "/manage/connections";
      preLoaderRoute: typeof ManageConnectionsRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/credits": {
      id: "/manage/credits";
      path: "/credits";
      fullPath: "/manage/credits";
      preLoaderRoute: typeof ManageCreditsRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/data-events": {
      id: "/manage/data-events";
      path: "/data-events";
      fullPath: "/manage/data-events";
      preLoaderRoute: typeof ManageDataEventsRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/llm-logs": {
      id: "/manage/llm-logs";
      path: "/llm-logs";
      fullPath: "/manage/llm-logs";
      preLoaderRoute: typeof ManageLlmLogsRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/members": {
      id: "/manage/members";
      path: "/members";
      fullPath: "/manage/members";
      preLoaderRoute: typeof ManageMembersRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/org": {
      id: "/manage/org";
      path: "/org";
      fullPath: "/manage/org";
      preLoaderRoute: typeof ManageOrgRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/platform-writes": {
      id: "/manage/platform-writes";
      path: "/platform-writes";
      fullPath: "/manage/platform-writes";
      preLoaderRoute: typeof ManagePlatformWritesRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/s/$slug": {
      id: "/s/$slug";
      path: "/s/$slug";
      fullPath: "/s/$slug";
      preLoaderRoute: typeof SSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/admin/org": {
      id: "/_app/admin/org";
      path: "/admin/org";
      fullPath: "/admin/org";
      preLoaderRoute: typeof AppAdminOrgRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/plan/": {
      id: "/_app/plan/";
      path: "/";
      fullPath: "/plan/";
      preLoaderRoute: typeof AppPlanIndexRouteImport;
      parentRoute: typeof AppPlanRoute;
    };
    "/_app/plan/all-work": {
      id: "/_app/plan/all-work";
      path: "/all-work";
      fullPath: "/plan/all-work";
      preLoaderRoute: typeof AppPlanAllWorkRouteImport;
      parentRoute: typeof AppPlanRoute;
    };
    "/_app/settings/profile": {
      id: "/_app/settings/profile";
      path: "/settings/profile";
      fullPath: "/settings/profile";
      preLoaderRoute: typeof AppSettingsProfileRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/v/$proposalId": {
      id: "/_app/v/$proposalId";
      path: "/v/$proposalId";
      fullPath: "/v/$proposalId";
      preLoaderRoute: typeof AppVProposalIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/manage/apps/": {
      id: "/manage/apps/";
      path: "/apps";
      fullPath: "/manage/apps/";
      preLoaderRoute: typeof ManageAppsIndexRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/apps/$id": {
      id: "/manage/apps/$id";
      path: "/apps/$id";
      fullPath: "/manage/apps/$id";
      preLoaderRoute: typeof ManageAppsIdRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/datasets/": {
      id: "/manage/datasets/";
      path: "/datasets";
      fullPath: "/manage/datasets/";
      preLoaderRoute: typeof ManageDatasetsIndexRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/objectives/": {
      id: "/manage/objectives/";
      path: "/objectives";
      fullPath: "/manage/objectives/";
      preLoaderRoute: typeof ManageObjectivesIndexRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/objectives/$id": {
      id: "/manage/objectives/$id";
      path: "/objectives/$id";
      fullPath: "/manage/objectives/$id";
      preLoaderRoute: typeof ManageObjectivesIdRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/projects/": {
      id: "/manage/projects/";
      path: "/projects";
      fullPath: "/manage/projects/";
      preLoaderRoute: typeof ManageProjectsIndexRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/projects/$id": {
      id: "/manage/projects/$id";
      path: "/projects/$id";
      fullPath: "/manage/projects/$id";
      preLoaderRoute: typeof ManageProjectsIdRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/sites/": {
      id: "/manage/sites/";
      path: "/sites";
      fullPath: "/manage/sites/";
      preLoaderRoute: typeof ManageSitesIndexRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/workspaces/": {
      id: "/manage/workspaces/";
      path: "/workspaces";
      fullPath: "/manage/workspaces/";
      preLoaderRoute: typeof ManageWorkspacesIndexRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/workspaces/$id": {
      id: "/manage/workspaces/$id";
      path: "/workspaces/$id";
      fullPath: "/manage/workspaces/$id";
      preLoaderRoute: typeof ManageWorkspacesIdRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/_app/plan/o/$objectiveSlug": {
      id: "/_app/plan/o/$objectiveSlug";
      path: "/o/$objectiveSlug";
      fullPath: "/plan/o/$objectiveSlug";
      preLoaderRoute: typeof AppPlanOObjectiveSlugRouteImport;
      parentRoute: typeof AppPlanRoute;
    };
    "/_app/plan/p/$projectSlug": {
      id: "/_app/plan/p/$projectSlug";
      path: "/p/$projectSlug";
      fullPath: "/plan/p/$projectSlug";
      preLoaderRoute: typeof AppPlanPProjectSlugRouteImport;
      parentRoute: typeof AppPlanRoute;
    };
    "/_app/plan/w/$slug": {
      id: "/_app/plan/w/$slug";
      path: "/w/$slug";
      fullPath: "/plan/w/$slug";
      preLoaderRoute: typeof AppPlanWSlugRouteImport;
      parentRoute: typeof AppPlanRoute;
    };
    "/_app/w/$slug/": {
      id: "/_app/w/$slug/";
      path: "/w/$slug";
      fullPath: "/w/$slug/";
      preLoaderRoute: typeof AppWSlugIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/w/$slug/threads": {
      id: "/_app/w/$slug/threads";
      path: "/w/$slug/threads";
      fullPath: "/w/$slug/threads";
      preLoaderRoute: typeof AppWSlugThreadsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/manage/datasets/$id/": {
      id: "/manage/datasets/$id/";
      path: "/datasets/$id";
      fullPath: "/manage/datasets/$id/";
      preLoaderRoute: typeof ManageDatasetsIdIndexRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/manage/datasets/$id/data": {
      id: "/manage/datasets/$id/data";
      path: "/datasets/$id/data";
      fullPath: "/manage/datasets/$id/data";
      preLoaderRoute: typeof ManageDatasetsIdDataRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/_app/plan/o/$objectiveSlug/": {
      id: "/_app/plan/o/$objectiveSlug/";
      path: "/";
      fullPath: "/plan/o/$objectiveSlug/";
      preLoaderRoute: typeof AppPlanOObjectiveSlugIndexRouteImport;
      parentRoute: typeof AppPlanOObjectiveSlugRoute;
    };
    "/_app/plan/p/$projectSlug/": {
      id: "/_app/plan/p/$projectSlug/";
      path: "/";
      fullPath: "/plan/p/$projectSlug/";
      preLoaderRoute: typeof AppPlanPProjectSlugIndexRouteImport;
      parentRoute: typeof AppPlanPProjectSlugRoute;
    };
    "/_app/w/$slug/c/$canvasId": {
      id: "/_app/w/$slug/c/$canvasId";
      path: "/w/$slug/c/$canvasId";
      fullPath: "/w/$slug/c/$canvasId";
      preLoaderRoute: typeof AppWSlugCCanvasIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/w/$slug/cases/$caseId": {
      id: "/_app/w/$slug/cases/$caseId";
      path: "/w/$slug/cases/$caseId";
      fullPath: "/w/$slug/cases/$caseId";
      preLoaderRoute: typeof AppWSlugCasesCaseIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/manage/datasets/$id/files/$assetId": {
      id: "/manage/datasets/$id/files/$assetId";
      path: "/datasets/$id/files/$assetId";
      fullPath: "/manage/datasets/$id/files/$assetId";
      preLoaderRoute: typeof ManageDatasetsIdFilesAssetIdRouteImport;
      parentRoute: typeof ManageRoute;
    };
    "/_app/plan/o/$objectiveSlug/kr/$krId": {
      id: "/_app/plan/o/$objectiveSlug/kr/$krId";
      path: "/kr/$krId";
      fullPath: "/plan/o/$objectiveSlug/kr/$krId";
      preLoaderRoute: typeof AppPlanOObjectiveSlugKrKrIdRouteImport;
      parentRoute: typeof AppPlanOObjectiveSlugRoute;
    };
    "/_app/plan/p/$projectSlug/wp/$wpId": {
      id: "/_app/plan/p/$projectSlug/wp/$wpId";
      path: "/wp/$wpId";
      fullPath: "/plan/p/$projectSlug/wp/$wpId";
      preLoaderRoute: typeof AppPlanPProjectSlugWpWpIdRouteImport;
      parentRoute: typeof AppPlanPProjectSlugRoute;
    };
    "/_app/w/$slug/c/$canvasId/a/$artifactId": {
      id: "/_app/w/$slug/c/$canvasId/a/$artifactId";
      path: "/a/$artifactId";
      fullPath: "/w/$slug/c/$canvasId/a/$artifactId";
      preLoaderRoute: typeof AppWSlugCCanvasIdAArtifactIdRouteImport;
      parentRoute: typeof AppWSlugCCanvasIdRoute;
    };
    "/_app/plan/p/$projectSlug/wp/$wpId/t/$taskId": {
      id: "/_app/plan/p/$projectSlug/wp/$wpId/t/$taskId";
      path: "/t/$taskId";
      fullPath: "/plan/p/$projectSlug/wp/$wpId/t/$taskId";
      preLoaderRoute: typeof AppPlanPProjectSlugWpWpIdTTaskIdRouteImport;
      parentRoute: typeof AppPlanPProjectSlugWpWpIdRoute;
    };
  }
}

interface AppPlanOObjectiveSlugRouteChildren {
  AppPlanOObjectiveSlugIndexRoute: typeof AppPlanOObjectiveSlugIndexRoute;
  AppPlanOObjectiveSlugKrKrIdRoute: typeof AppPlanOObjectiveSlugKrKrIdRoute;
}

const AppPlanOObjectiveSlugRouteChildren: AppPlanOObjectiveSlugRouteChildren = {
  AppPlanOObjectiveSlugIndexRoute: AppPlanOObjectiveSlugIndexRoute,
  AppPlanOObjectiveSlugKrKrIdRoute: AppPlanOObjectiveSlugKrKrIdRoute,
};

const AppPlanOObjectiveSlugRouteWithChildren =
  AppPlanOObjectiveSlugRoute._addFileChildren(
    AppPlanOObjectiveSlugRouteChildren,
  );

interface AppPlanPProjectSlugWpWpIdRouteChildren {
  AppPlanPProjectSlugWpWpIdTTaskIdRoute: typeof AppPlanPProjectSlugWpWpIdTTaskIdRoute;
}

const AppPlanPProjectSlugWpWpIdRouteChildren: AppPlanPProjectSlugWpWpIdRouteChildren =
  {
    AppPlanPProjectSlugWpWpIdTTaskIdRoute:
      AppPlanPProjectSlugWpWpIdTTaskIdRoute,
  };

const AppPlanPProjectSlugWpWpIdRouteWithChildren =
  AppPlanPProjectSlugWpWpIdRoute._addFileChildren(
    AppPlanPProjectSlugWpWpIdRouteChildren,
  );

interface AppPlanPProjectSlugRouteChildren {
  AppPlanPProjectSlugIndexRoute: typeof AppPlanPProjectSlugIndexRoute;
  AppPlanPProjectSlugWpWpIdRoute: typeof AppPlanPProjectSlugWpWpIdRouteWithChildren;
}

const AppPlanPProjectSlugRouteChildren: AppPlanPProjectSlugRouteChildren = {
  AppPlanPProjectSlugIndexRoute: AppPlanPProjectSlugIndexRoute,
  AppPlanPProjectSlugWpWpIdRoute: AppPlanPProjectSlugWpWpIdRouteWithChildren,
};

const AppPlanPProjectSlugRouteWithChildren =
  AppPlanPProjectSlugRoute._addFileChildren(AppPlanPProjectSlugRouteChildren);

interface AppPlanRouteChildren {
  AppPlanAllWorkRoute: typeof AppPlanAllWorkRoute;
  AppPlanIndexRoute: typeof AppPlanIndexRoute;
  AppPlanOObjectiveSlugRoute: typeof AppPlanOObjectiveSlugRouteWithChildren;
  AppPlanPProjectSlugRoute: typeof AppPlanPProjectSlugRouteWithChildren;
  AppPlanWSlugRoute: typeof AppPlanWSlugRoute;
}

const AppPlanRouteChildren: AppPlanRouteChildren = {
  AppPlanAllWorkRoute: AppPlanAllWorkRoute,
  AppPlanIndexRoute: AppPlanIndexRoute,
  AppPlanOObjectiveSlugRoute: AppPlanOObjectiveSlugRouteWithChildren,
  AppPlanPProjectSlugRoute: AppPlanPProjectSlugRouteWithChildren,
  AppPlanWSlugRoute: AppPlanWSlugRoute,
};

const AppPlanRouteWithChildren =
  AppPlanRoute._addFileChildren(AppPlanRouteChildren);

interface AppWSlugCCanvasIdRouteChildren {
  AppWSlugCCanvasIdAArtifactIdRoute: typeof AppWSlugCCanvasIdAArtifactIdRoute;
}

const AppWSlugCCanvasIdRouteChildren: AppWSlugCCanvasIdRouteChildren = {
  AppWSlugCCanvasIdAArtifactIdRoute: AppWSlugCCanvasIdAArtifactIdRoute,
};

const AppWSlugCCanvasIdRouteWithChildren =
  AppWSlugCCanvasIdRoute._addFileChildren(AppWSlugCCanvasIdRouteChildren);

interface AppRouteChildren {
  AppOnboardingRoute: typeof AppOnboardingRoute;
  AppPlanRoute: typeof AppPlanRouteWithChildren;
  AppWorkspacesRoute: typeof AppWorkspacesRoute;
  AppAdminOrgRoute: typeof AppAdminOrgRoute;
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute;
  AppVProposalIdRoute: typeof AppVProposalIdRoute;
  AppWSlugThreadsRoute: typeof AppWSlugThreadsRoute;
  AppWSlugIndexRoute: typeof AppWSlugIndexRoute;
  AppWSlugCCanvasIdRoute: typeof AppWSlugCCanvasIdRouteWithChildren;
  AppWSlugCasesCaseIdRoute: typeof AppWSlugCasesCaseIdRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppOnboardingRoute: AppOnboardingRoute,
  AppPlanRoute: AppPlanRouteWithChildren,
  AppWorkspacesRoute: AppWorkspacesRoute,
  AppAdminOrgRoute: AppAdminOrgRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppVProposalIdRoute: AppVProposalIdRoute,
  AppWSlugThreadsRoute: AppWSlugThreadsRoute,
  AppWSlugIndexRoute: AppWSlugIndexRoute,
  AppWSlugCCanvasIdRoute: AppWSlugCCanvasIdRouteWithChildren,
  AppWSlugCasesCaseIdRoute: AppWSlugCasesCaseIdRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

interface AuthRouteChildren {
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute;
  AuthSigninRoute: typeof AuthSigninRoute;
  AuthSignupRoute: typeof AuthSignupRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSetPasswordRoute: AuthSetPasswordRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

interface ManageRouteChildren {
  ManageBillingRoute: typeof ManageBillingRoute;
  ManageConnectionsRoute: typeof ManageConnectionsRoute;
  ManageCreditsRoute: typeof ManageCreditsRoute;
  ManageDataEventsRoute: typeof ManageDataEventsRoute;
  ManageLlmLogsRoute: typeof ManageLlmLogsRoute;
  ManageMembersRoute: typeof ManageMembersRoute;
  ManageOrgRoute: typeof ManageOrgRoute;
  ManagePlatformWritesRoute: typeof ManagePlatformWritesRoute;
  ManageIndexRoute: typeof ManageIndexRoute;
  ManageAppsIdRoute: typeof ManageAppsIdRoute;
  ManageObjectivesIdRoute: typeof ManageObjectivesIdRoute;
  ManageProjectsIdRoute: typeof ManageProjectsIdRoute;
  ManageWorkspacesIdRoute: typeof ManageWorkspacesIdRoute;
  ManageAppsIndexRoute: typeof ManageAppsIndexRoute;
  ManageDatasetsIndexRoute: typeof ManageDatasetsIndexRoute;
  ManageObjectivesIndexRoute: typeof ManageObjectivesIndexRoute;
  ManageProjectsIndexRoute: typeof ManageProjectsIndexRoute;
  ManageSitesIndexRoute: typeof ManageSitesIndexRoute;
  ManageWorkspacesIndexRoute: typeof ManageWorkspacesIndexRoute;
  ManageDatasetsIdDataRoute: typeof ManageDatasetsIdDataRoute;
  ManageDatasetsIdIndexRoute: typeof ManageDatasetsIdIndexRoute;
  ManageDatasetsIdFilesAssetIdRoute: typeof ManageDatasetsIdFilesAssetIdRoute;
}

const ManageRouteChildren: ManageRouteChildren = {
  ManageBillingRoute: ManageBillingRoute,
  ManageConnectionsRoute: ManageConnectionsRoute,
  ManageCreditsRoute: ManageCreditsRoute,
  ManageDataEventsRoute: ManageDataEventsRoute,
  ManageLlmLogsRoute: ManageLlmLogsRoute,
  ManageMembersRoute: ManageMembersRoute,
  ManageOrgRoute: ManageOrgRoute,
  ManagePlatformWritesRoute: ManagePlatformWritesRoute,
  ManageIndexRoute: ManageIndexRoute,
  ManageAppsIdRoute: ManageAppsIdRoute,
  ManageObjectivesIdRoute: ManageObjectivesIdRoute,
  ManageProjectsIdRoute: ManageProjectsIdRoute,
  ManageWorkspacesIdRoute: ManageWorkspacesIdRoute,
  ManageAppsIndexRoute: ManageAppsIndexRoute,
  ManageDatasetsIndexRoute: ManageDatasetsIndexRoute,
  ManageObjectivesIndexRoute: ManageObjectivesIndexRoute,
  ManageProjectsIndexRoute: ManageProjectsIndexRoute,
  ManageSitesIndexRoute: ManageSitesIndexRoute,
  ManageWorkspacesIndexRoute: ManageWorkspacesIndexRoute,
  ManageDatasetsIdDataRoute: ManageDatasetsIdDataRoute,
  ManageDatasetsIdIndexRoute: ManageDatasetsIdIndexRoute,
  ManageDatasetsIdFilesAssetIdRoute: ManageDatasetsIdFilesAssetIdRoute,
};

const ManageRouteWithChildren =
  ManageRoute._addFileChildren(ManageRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ManageRoute: ManageRouteWithChildren,
  SharedRoute: SharedRoute,
  InviteTokenRoute: InviteTokenRoute,
  SSlugRoute: SSlugRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
